// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"54":"7948952d","401":"18ccea3f","503":"23f7498b","959":"a532f862"}[chunkId] + ".chunk.css";
};